module.exports = __webpack_public_path__ + "static/media/x.4ddd48fc.svg";